import HttpResponse from "../../../../../utils/http/http.response";

export enum UserDriverListResponseItemAddressType {
  STARTING = "STARTING",
  MAILING = "MAILING",
}

export enum UserDriverListResponseItemDriverCarOwnership {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export type UserDriverListResponseItemAddress = {
  town: string | null;
  zipCode: string | null;
  type: UserDriverListResponseItemAddressType;
};

export type UserDriverListResponseItemTaxiAssociationFleetPartner = {
  name: string;
};

export type UserDriverListResponseItemTaxiDriverAssociationTaxiCorporation = {
  displayName: string;
};

export type UserDriverListResponseItemTaxiDriverAssociation = {
  fleetPartner: UserDriverListResponseItemTaxiAssociationFleetPartner | null;
  taxiCorporation: UserDriverListResponseItemTaxiDriverAssociationTaxiCorporation;
};

export type UserDriverListResponseItemDriver = {
  addresses: UserDriverListResponseItemAddress[];
  carMake: string | null;
  carModel: string | null;
  carOwnership: UserDriverListResponseItemDriverCarOwnership;
  carProdYear: number | null;
  taxiDriverAssociations: UserDriverListResponseItemTaxiDriverAssociation[];
  lastPlanEntryEndTime: Date | null;
};

export type UserDriverListResponseItem = {
  removedAt: Date | null;
  id: string;
  modifiedAt: Date | null;
  createdAt: Date;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
  mobileSecondaryPrefix: string | null;
  mobileSecondary: string | null;
  driver: UserDriverListResponseItemDriver;
  pendingCandidature: boolean;
  createdByName: string;
  modifiedByName: string | null;
};

type UserDriverListResponse = HttpResponse<{
  data: UserDriverListResponseItem[];
  totalCount: number;
}>;

export default UserDriverListResponse;
